<nav class="sticky">
  <div class="site-width bg-white">
    <div class="container-fluid">
      <nav class="sticky-navbar navbar mx-0">
        <h1 class="pl-0 pb-0 mb-0 mb-md-2 no-signature menu-title" data-e2e="e2e-ecm-visitor-menu-title">
          {{"ecm.menu.title" | translate}}
        </h1>
      </nav>
      <div class="h1 d-block d-md-none menu-subtitle mb-0 pb-1" data-e2e="e2e-ecm-visitor-menu-subtitle">
        <div class="d-flex align-items-center">
          <span>Accueil</span>
        </div>
      </div>
    </div>
  </div>
</nav>
<hr class="separator separator--gray4" />
